export default __webpack_public_path__ + "static/media/img-18-linden.0c054a28.jpg";